<div
  class="side-nav-bar"
  [ngClass]="{
    'side-nav-bar__menu__not-active': !isMenuExpanded,
    'side-nav-bar__menu__active': isMenuExpanded
  }"
>
  <button
    data-testid="left-menu-arrow"
    class="side-nav-bar__menu__arrow"
    [ngClass]="{
      'side-nav-bar__menu__arrow-right': !isMenuExpanded,
      'side-nav-bar__menu__arrow-left': isMenuExpanded
    }"
    (click)="setActiveClass()"
  >
    <img src="{{ showhideMenu }}" alt="url" />
  </button>

  <div class="side-nav-bar__menu">
    <div *ngFor="let item of menuOptions">
      <div
        *ngIf="item.visible"
        [ngClass]="{ 'side-nav-bar__menu__item-selected': item.selected }"
        [id]="item.id"
        data-testid="left-menu-item"
      >
        <a
          class="side-nav-bar__menu__item"
          [attr.href]="item.isExternal ? item.url : null"
          (click)="onItemClick($event, item)"
        >
          <img src="{{ item.icon }}" alt="url" />
          <div [hidden]="!isMenuExpanded" class="side-nav-bar__menu__item__text">
            {{ item.name | translate }}
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
